import { Box, Container, Divider, Typography } from "@mui/material"

const questions = [
  {
    question: "Q1.準委任の案件以外に、請負の案件はありますか？",
    answer:
      "申し訳ございません。弊社でお取り扱い中の案件は準委任契約が中心となっております。請負は稀な状況でございます。もし請負がご希望でしたら一度ご連絡くださいませ。",
  },
  {
    question: "Q2.稼働後にサポートはありますか？",
    answer:
      "業務に集中できるよう、請求書の作成や報酬の徴収を代行しております。また、業務内で不安な点などのフォローもしておりますのでご安心ください。",
  },
  {
    question: "Q3.時間単価や稼働日数の調整は可能ですか？",
    answer:
      "弊社から企業様に交渉は可能ですのでご連絡くださいませ。契約内容・稼働時間・単価等が変更になる場合は別途、覚書を締結する必要がありますのでご了承くださいませ。",
  },
]
export default function LandingFAQ() {
  return (
    <Box sx={{ mt: "10em" }}>
      <Typography
        variant="h3"
        color="primary"
        sx={{ textAlign: "center", mt: 5, fontWeight: "bold" }}
      >
        よくある質問
      </Typography>
      <Divider sx={{ mx: 4, my: 2, borderBottomWidth: 2 }} />
      {questions.map((question, index) => (
        <Container sx={{ pb: 3 }} key={index}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {question.question}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            {question.answer}
          </Typography>
        </Container>
      ))}
    </Box>
  )
}
